
import { removeCookie } from "@/utils/cookie";
import { getMarkVersion,updateMarkVersion } from "./callingAppApi";
export function getUid() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
}
export function replaceTagCode(msgText='', info) {
  // console.log('inof', info);
  return msgText
    .replace(/#学生编码# ?/g, info.studentCode)
    .replace(/#学生姓名# ?/g, info.studentName)
    .replace(/#沟通称呼语# ?/g, info.nickName)
    .replace(/#学生昵称# ?/g, info.nickName);
}
export function formatTime(timeStamp) {
  const date = new Date(timeStamp);
  const formatNum = (num) => (num < 10 ? '0' : '') + num;
  let Y = formatNum(date.getFullYear());
  let M = formatNum(date.getMonth() + 1);
  let D = formatNum(date.getDate());
  let h = formatNum(date.getHours());
  let m = formatNum(date.getMinutes());
  let s = formatNum(date.getSeconds());
  return `${Y}-${M}-${D} ${h}:${m}:${s}`;
}

export const formatRetainTime = (retainTime) => {
  let hours = Math.floor(retainTime / 3600); // 小时数
  let minutes = Math.floor((retainTime % 3600) / 60); // 分钟数
  let seconds = retainTime % 60; // 秒数
  let timeString = ''; // 时间字符串

  // 如果有小时，添加小时部分
  if (hours > 0) {
    timeString += hours + '小时';
  }

  // 如果有分钟，添加分钟部分
  if (minutes > 0) {
    timeString += minutes + '分钟';
  }

  // 如果有秒，并且时间小于3分钟，添加秒部分
  if (seconds > 0 && hours === 0 && minutes < 3) {
    timeString += seconds + '秒';
  }

  return timeString;
}

export function getDeviceInfoFromStorage() {
  let deviceInfoStr = localStorage.getItem('deviceInfo');
  try {
    return JSON.parse(deviceInfoStr) || {};
  } catch (error) {
    return {};
  }
}

export function clearCookie(){
  removeCookie('x3mf')
  removeCookie('x3mf',{
    domain:'.xdf.cn',
    path: '/'
  })
  removeCookie('x3mf',{
    domain:'xdf.cn',
    path: '/'
  }) //teach-assist.xdf.cn
  removeCookie('x3mf',{
    domain:'nppss-test1.test123.xdf.cn',
    path: '/'
  })
  removeCookie('x3mf',{
    domain:'teach-assist.xdf.cn',
    path: '/'
  })

  removeCookie('e2e')
  removeCookie('e2e',{
    domain:'.xdf.cn',
    path: '/'
  })
  removeCookie('e2e',{
    domain:'xdf.cn',
    path: '/'
  }) //teach-assist.xdf.cn
  removeCookie('e2e',{
    domain:'nppss-test1.test123.xdf.cn',
    path: '/'
  })
  removeCookie('e2e',{
    domain:'teach-assist.xdf.cn',
    path: '/'
  })
  
  removeCookie('e2mf')
  removeCookie('e2mf',{
    domain:'.xdf.cn',
    path: '/'
  })
  removeCookie('e2mf',{
    domain:'xdf.cn',
    path: '/'
  }) //teach-assist.xdf.cn
  removeCookie('e2mf',{
    domain:'nppss-test1.test123.xdf.cn',
    path: '/'
  })
  removeCookie('e2mf',{
    domain:'teach-assist.xdf.cn',
    path: '/'
  })

  removeCookie('identify')
  removeCookie('identify',{
    domain:'.xdf.cn',
    path: '/'
  })
  removeCookie('identify',{
    domain:'xdf.cn',
    path: '/'
  }) //teach-assist.xdf.cn
  removeCookie('identify',{
    domain:'nppss-test1.test123.xdf.cn',
    path: '/'
  })
  removeCookie('identify',{
    domain:'teach-assist.xdf.cn',
    path: '/'
  })
}

export function selfGetStorage(key){
  return new Promise((resolve,reject)=>{
    getMarkVersion({markKey:key},(res)=>{
      console.log('selfGetStorage',res)
      resolve(res.data.version)
    })
  })
  
}
export function selfSetStorage(key,value){
  updateMarkVersion({
    markKey:key,version:value
  })
}
export function sortByName(list){
  return  list.sort((a,b)=>{
    return a.studentName.localeCompare(b.studentName,'zh')
  })
}
export function isUpThisVer(ver){
  const deviceInfo = getDeviceInfoFromStorage()
  let currentAppVersion = deviceInfo?.appVer || deviceInfo?.appVersion || '1.0.3';
  let currentAppVerNum = currentAppVersion.split('.').map(item=>item.length == 1 ? '0'+item : item).join('')/1;
  let targetVerNum = ver.split('.').map(item=>item.length == 1 ? '0'+item : item).join('')/1;
  return currentAppVerNum > targetVerNum
}

export function resolveReportDataByStartTime(sendData,reportData){
  // console.log('sendData',sendData)
  // console.log('reportData',reportData)
  reportData.chats.forEach((chat,chatIndex)=>{
    const sendDataChat = sendData.chats[chatIndex];
    if(chat.start_time){
      // 若上报的数据中有 start_time或者 备注换了 或者 学生换了 都要更新
      chat.needUpdate = true;
    }
    chat.msgs.forEach((msg,msgIndex)=>{
      const sendDataMsg = sendDataChat.msgs[msgIndex];
      if(msg.start_time){
        msg.needUpdate = true;
      }
    })
  })
  return reportData;
}

export const getFileName = (path = '') => {
  let fileName = '';
  path.replace(/[^\/\\]+\.[^?]+/, (a) => {
    fileName = a;
  })
  return fileName
}